import { render } from "./ContentImage.vue?vue&type=template&id=1a80a440"
import script from "./ContentImage.vue?vue&type=script&lang=js"
export * from "./ContentImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__